var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',_vm._g(_vm._b({staticClass:"simple-radio-checkbox",attrs:{"color":"#9FF4A9","on-icon":"ic-on","off-icon":"ic-off","ripple":false}},'v-radio',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }